import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Icon } from '../Icon';
const favoriteIconButtonStyles = css `
  ${styleUtils.buttonReset}
  color: ${theme.colors.accent600};

  &:hover {
    cursor: pointer;
    color: ${theme.colors.accent800};
  }

  &:disabled {
    color: ${theme.colors.gray400};
  }
`;
const defaultProps = {
    className: '',
};
const FavoriteIconButton = ({ className = defaultProps.className, favorited, onFavoriteClick, size, }) => (_jsx("button", Object.assign({ className: className, css: favoriteIconButtonStyles, onClick: onFavoriteClick, type: "button" }, { children: _jsx(Icon, { size: size, type: favorited ? 'favorited' : 'favorite' }) })));
const MemoizedFavoriteIconButton = memo(FavoriteIconButton);
export { MemoizedFavoriteIconButton as FavoriteIconButton };
// MC-1068 Temporary hack for Storybook.
export default FavoriteIconButton;
